module.exports = __webpack_public_path__ + "static/media/image-searcher.c071c5a1.png";